export default __webpack_public_path__ + "915ca30cba1123d38ebdb2c938e5b1ff.svg";